import { OrdersModel } from '@pukka/api';
import { numberUtils } from '@pukka/common/utils';
import { Text } from '@pukka/ui-components';

type OrderDiscount = OrdersModel.OrderDiscount & { finalAmount: number };

interface RefundDiscountProps {
  readonly paymentDiscounts?: OrderDiscount[];
}

function RefundDiscount({ paymentDiscounts }: RefundDiscountProps) {
  return (paymentDiscounts || []).length > 0 ? (
    <div className="mb-4">
      <Text weight="semibold" className="py-2">
        Discount
      </Text>
      {paymentDiscounts?.map((discount, idx) => {
        return (
          <div key={idx} className="flex justify-between border-t py-2">
            <Text>{discount.discount_name}</Text>
            <Text>{Number.isFinite(-discount.finalAmount) && `(${numberUtils.formatCurrency(discount.finalAmount, 'Rp.')})`}</Text>
          </div>
        );
      })}
    </div>
  ) : null;
}

export default RefundDiscount;
